import { render, staticRenderFns } from "./input-reorder-mini.vue?vue&type=template&id=98ec4102&scoped=true&"
import script from "./input-reorder-mini.vue?vue&type=script&lang=js&"
export * from "./input-reorder-mini.vue?vue&type=script&lang=js&"
import style0 from "./input-reorder-mini.vue?vue&type=style&index=0&id=98ec4102&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ec4102",
  null
  
)

export default component.exports